module.exports = __webpack_public_path__ + "static/img/beian.9f7f95f0.png";